import React, { useRef, useState } from 'react';
import TermsOfService from 'modules/Policy/model/TermsOfService';
import { supportedLangs } from 'modules/Shared/configs/supportedLang/config';
import DisplayNav from 'modules/Layout/view/Details/Helper/DisplayNav';
import InformationList from 'modules/Layout/component/InformationList';
import { useHistory } from 'react-router-dom';
import { getPathUrl } from 'modules/Shared/helper/api';
import { ROUTE_TOS_LIST, ROUTE_UPDATE_TOS } from 'modules/Policy/routes';
import ActionUpdate from 'modules/Layout/component/Action/Update';
import DeleteTermsOfServiceModal from 'modules/Policy/component/Modal/Delete';
import ActionDelete from 'modules/Layout/component/Action/Delete';

export interface Props {
  termsOfService: TermsOfService;
}

const TermsOfServiceDetails = (props: Props): JSX.Element => {
  const { termsOfService } = props;
  const [nav, setNav] = useState(supportedLangs.map((_, index) => index === 0));
  const deleteModalRef = useRef(null);
  const history = useHistory();
  const activeLangIndex = nav.findIndex((obj) => obj);
  const activeLang = supportedLangs[activeLangIndex];

  const fields = [
    {
      label: 'Activation date:',
      value: termsOfService.activation_date
    },
    {
      label: 'Published:',
      value: termsOfService.getIsPublished()
    },
    {
      label: 'Mails sent at:',
      value: termsOfService.mails_sended
    },
    {
      label: 'Created at:',
      value: termsOfService.created_at
    }
  ];

  return (
    <div className="card">
      <div className="card-body">
        <DeleteTermsOfServiceModal
          ref={deleteModalRef}
          onSuccess={() => history.push(getPathUrl(ROUTE_TOS_LIST))}
        />
        {!termsOfService.published && (
          <div className="d-flex justify-content-end actions-wrapper">
            <ActionUpdate
              title="Edit terms of service"
              className="mr-2"
              to={getPathUrl(ROUTE_UPDATE_TOS, { id: termsOfService.id })}
            />
            <ActionDelete
              title="Delete terms of service"
              onClick={() => deleteModalRef?.current?.open(termsOfService)}
            />
          </div>
        )}
        <InformationList fields={fields} />
        <hr className="border my-3" />
        <div className="details-top-nav mb-3">
          <DisplayNav
            booleanArr={nav}
            setBooleanArr={setNav}
            valueArr={supportedLangs}
          />
        </div>
        {supportedLangs.map((lang) => {
          const body = termsOfService.langs[lang]?.body;

          if (activeLang !== lang) {
            return null;
          }

          return (
            <div
              className="wysiwyg-preview"
              key={lang}
              dangerouslySetInnerHTML={{ __html: body }}
            />
          );
        })}
      </div>
    </div>
  );
};

export default TermsOfServiceDetails;
